// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "6ef0e16dddad7eac8d13c28acb29eb0c08668554",
  version: "1.126.0",
};
